// The MyKad verifying bar's next value (#111): the server's done/total as a whole percentage, never
// lower than what this screen already shows. A reading that cannot be used (no total, not a number)
// keeps the bar where it is; under the clamp a NaN would otherwise stick for the rest of the screen.
// The value lives in the Verifying screen's own state, and a retake always shows a new Verifying
// screen, so each attempt starts again from 0.
export function nextProgress(shown, done, total) {
  if (!(total > 0)) return shown;
  const reading = Math.floor((done / total) * 100);
  if (!Number.isFinite(reading)) return shown;
  return Math.max(shown, reading);
}
